import { formatDate } from "@miplatform/utils";
import { ACCOUNTING_TABS_NAMES } from "../accountingConstants";
import { AllInvoiceActions } from "./AllInvoiceActions/AllInvoiceActions";
import { InvoicedInvoiceActions } from "./InvoicedInvoiceActions/InvoicedInvoiceActions";
import { PendingInvoiceActions } from "./PendingInvoiceActions/PendingInvoiceActions";
import { PreBillActions } from "./PreBillActions/PreBillActions";

/**
 * Configuration for different accounting list views based on tab selection.
 * Each configuration contains methods and components specific to the tab.
 */

export const ACCOUNTING_LIST_CONFIG = {
  [ACCOUNTING_TABS_NAMES.ALL]: { ActionsComponent: AllInvoiceActions },
  [ACCOUNTING_TABS_NAMES.PRE_BILL]: {
    fields: [
      { label: "Order Status", fieldKey: "orderStatus" },
      { label: "Completed Date", fieldKey: "completeDate" },
      { label: "Approved Start Date", fieldKey: "approvedStartDate" },
    ],

    getGroupedTitle: (groupKey) =>
      `Approved Start Date: ${groupKey === "Unknown" ? "Unknown" : groupKey}`,
    getGroupedCriteria: (item) =>
      item.approvedStartDate
        ? formatDate(item.approvedStartDate, "DD MMMM YYYY")
        : "Unknown",
    ActionsComponent: PreBillActions,
  },
  [ACCOUNTING_TABS_NAMES.PENDING_INVOICES]: {
    fields: [
      { label: "Order Status", fieldKey: "orderStatus" },
      { label: "Completed Date", fieldKey: "completeDate" },
      { label: "Approved Start Date", fieldKey: "approvedStartDate" },
    ],
    getGroupedTitle: (groupKey) =>
      `Approved Start Date: ${groupKey === "Unknown" ? "Unknown" : groupKey}`,
    getGroupedCriteria: (item) =>
      item.approvedStartDate
        ? formatDate(item.approvedStartDate, "DD MMMM YYYY")
        : "Unknown",
    ActionsComponent: PendingInvoiceActions,
  },
  [ACCOUNTING_TABS_NAMES.INVOICED]: {
    fields: [{ label: "Invoice Date", fieldKey: "invoiceDate" }],
    getGroupedTitle: (title) => `Scheduled Start Date: ${title}`,
    getGroupedCriteria: (item) =>
      formatDate(item.scheduledStartDate, "DD MMMM YYYY"),
    ActionsComponent: InvoicedInvoiceActions,
  },
};
